<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual text="디지털유통 혁신을 함께할 기술 스타트업을 찾습니다." src="/images/sub/sub-visual-pitching-festa.jpg">
                <template #titleContents>
                    <div class="sub-visual__tit-wrap mt-n20px">
                        <h2 class="sub-visual__tit"><span class="font-size-lg-100 font-weight-bold">e</span>커머스피칭페스타 지원</h2>
                    </div>
                </template>
            </sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first py-30px py-md-40px">
            <v-row align="center">
                <v-col cols="12" md="auto" data-aos="fade-right" data-aos-delay="100">
                    <v-card outlined width="150" class="border-light mx-auto">
                        <v-img width="100%" :aspect-ratio="150 / 150" :src="startup?.thumb?.src" />
                    </v-card>
                </v-col>
                <v-col cols="12" md="" data-aos="fade-left" data-aos-delay="100">
                    <card-board :chip="startup?.awardName" class="border-0">
                        <template #titleSlot>
                            <div class="tit tit--xs mt-n4px">{{ startup?.name }}</div>
                        </template>
                        <template #textSlot>
                            <p class="txt txt--lg txt--dark mt-6px">{{ startup?.description }}</p>
                        </template>

                        <template #hash>
                            <div class="mt-16px mt-md-24px">
                                <v-row class="row--xs">
                                    <v-col v-for="hashTag, index in startup?.hashTags" :key="index" cols="auto">
                                        <span class="txt txt--xs primary--text">#{{ hashTag }}</span>
                                    </v-col>
                                </v-row>
                            </div>
                        </template>

                    </card-board>
                </v-col>
            </v-row>
        </page-section>

        <page-section class="page-section--last pt-30px pt-md-40px grey lighten-5">
            <v-row>
                <v-col cols="12" lg="4" order-lg="2" data-aos="fade-up" data-aos-delay="200">
                    <v-card color="white">
                        <div class="pa-20px pa-md-30px px-lg-24px py-lg-40px">
                            <div class="mb-10px">
                                <h3 class="tit tit--xxs">회사정보</h3>
                            </div>
                            <div v-for="information, index in startup?.information" :key="index">
                                <v-row class="row--sm">
                                    <v-col cols="auto">
                                        <div class="txt txt--sm txt--dark w-100px">{{ information?.title }}</div>
                                    </v-col>
                                    <v-col>
                                        <div v-html="information?.txt?.replace(/\n/g,'<br>')" class="txt txt--sm"></div>
                                        <div v-if="startup?.information?.length === index + 1" class="mt-10px">
                                            <v-btn x-large color="secondary" :href="startup.link" class="min-w-220px justify-space-between">
                                                웹사이트 바로가기
                                                <icon-arrow-rounded direction="right" class="icon--size-small ml-12px" />
                                            </v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                            <v-divider class="my-16px my-md-24px" />

                            <div v-for="item, index in startup?.helpItems" :key="index" :class="index !== 0 ? 'mt-16px mt-md-24px' : ''">
                                <div class="mb-10px">
                                    <h3 class="tit tit--xxs">{{ item?.title }}</h3>
                                </div>
                                <div v-html="item?.txt?.replace(/\n/g,'<br>')" class="txt txt--sm"></div>
                            </div>
                        </div>
                    </v-card>
                </v-col>
                <v-col cols="12" lg="8" order-lg="1" data-aos="fade-up" data-aos-delay="100">
                    <v-card color="white">
                        <div class="pa-20px pa-md-30px pa-lg-40px">

                            <div v-for="item, index in startup?.items" :key="index" :class="index !== 0 ? 'mt-16px mt-md-24px' : ''">
                                <div class="mb-10px">
                                    <h3 class="tit tit--xxs">{{ item?.title }}</h3>
                                </div>
                                <div v-html="item?.txt?.replace(/\n/g,'<br>')" class="txt txt--sm"></div>
                            </div>

                            <div v-for="youtubeLink, index in startup?.youtubeLink" :key="index" class="mt-16px mt-md-24px">
                                <v-responsive :aspect-ratio="560/315">
                                    <iframe width="100%" height="100%" :src="convertYouTubeURL(youtubeLink.title)" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                                </v-responsive>
                            </div>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </page-section>
    </client-page>
</template>

<script>
import api from "@/api";
import download from "downloadjs";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/components/dumb/page-section.vue";
import IconArrowRounded from "@/components/client/icons/icon-arrow-rounded.vue";
import IconDown from "@/components/client/icons/icon-down.vue";
import CardBoard from "@/components/dumb/card-board.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        IconArrowRounded,
        IconDown,
        CardBoard,
    },
    data() {
        return {
            startup: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        download: (url, name) => api.resource.get(url).then((file) => download(file, name)),

        async init() {
            let { startup } = await api.v1.kea.startups.get({ _id: this.$route.params._id });
            this.startup = startup;
        },

        convertYouTubeURL(url) {
            const videoId = url.match(/(?:\?v=|\/embed\/|\.be\/|\/v\/|\/\d{1,2}\/|\/embed\/|\/e\/|\/watch\?v=|\/\d{1,2}\/|\/v\/|\/e\/|\/watch\?v=|\/\d{1,2}\/|\/v\/|\/e\/|\/watch\?v=)([^#\&\?\/\s]{11})/);
            if (videoId) {
                return `https://www.youtube.com/embed/${videoId[1]}`;
            }
            return null;
        },
        shareKakao() {
            try {
                let key = ""; // 웹 API 키
                if (!key) throw new Error("카카오에서 JAVASCRIPT API 키를 발급받아 전달해주세요.(+ 카카오에 WEB 정보를 등록해주세요)");

                let shareUrl = location.href;

                if (!Kakao.isInitialized()) Kakao.init(key);
                Kakao.Share.sendDefault({
                    objectType: "feed",
                    content: {
                        title: this.startup.subject,
                        // description: '#케익 #딸기 #삼평동 #카페 #분위기 #소개팅',
                        imageUrl: `https://${location.host}/${this.startup.thumb.src}`,
                        link: {
                            // [내 애플리케이션] > [플랫폼] 에서 등록한 사이트 도메인과 일치해야 함
                            // mobileWebUrl: 'https://developers.kakao.com',
                            mobileWebUrl: shareUrl,
                            // webUrl: 'https://developers.kakao.com',
                            webUrl: shareUrl,
                        },
                    },
                });
            } catch (error) {
                alert(error.message);
            }
        },
        shareFacebook() {
            try {
                let shareUrl = location.href;

                location.href = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
            } catch (error) {
                alert(error.message);
            }
        },
        shareInstagram() {
            try {
                let client_id = ""; // 클라이언트 아이디
                if (!client_id) throw new Error("인스타그램 클라이언트 아이디를 발급받아 전달해주세요.");

                let shareUrl = location.href;

                location.href = `https://api.instagram.com/oauth/authorize/?client_id=${client_id}&redirect_uri=${shareUrl}&response_type=code`;
            } catch (error) {
                alert(error.message);
            }
        },
        copyClipboard() {
            try {
                if (!window?.navigator?.clipboard?.writeText) throw new Error("SSL 환경에서만 클립보드 복사 가능합니다");

                let shareUrl = location.href;

                window.navigator.clipboard.writeText(shareUrl);

                alert("복사 되었습니다");
            } catch (error) {
                alert(error.message);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .card-board {
        &__contents {
            min-height: auto;
            padding: 0;
            .h-34px {
                height: auto !important;
                margin-bottom: 10px;
            }
        }
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    ::v-deep {
        .card-board {
            &__contents {
                padding: 0;
            }
        }
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>
